import './header.less'

import {
	action,
	classes,
	Component,
	Icon,
	Image,
	MediaQuery
} from '@codeurs/front'
import searchImg from 'assets/icons/searchicon.svg'
import headerImg from 'assets/images/header.jpg'
import logo from 'assets/images/smeunited-logo-white.svg'
import m from 'mithril'
import {t} from 'store'
import {ImageType, LinkType} from 'types/types'
import Hamburger from 'views/layout/hamburger'
import Link from 'views/layout/link'

export default class Header extends Component<{
	links?: any
	menu: Array<LinkType>
	side_menu: Array<LinkType>
	channel: string
	showNav: boolean
	setNav: (value: boolean) => boolean
	header_image?: ImageType
	social: {links: any[]}
}> {
	showNav = false
	view() {
		const {channel, setNav, showNav, header_image} = this.attrs
		const headerImage =
			header_image && !header_image.empty ? header_image.src : headerImg
		return m('header.header', [
			m('.header-bg',
				{
					class: 'mod-' + channel,
					style: {
						backgroundImage: 'url(' + headerImage + ')'
					}
				},
				[
					m('.header-row', [
						m(MediaQuery, {
							maxWidth: 1199,
							view: () =>
								m(Hamburger, {
									class: 'header-row-hamburger',
									onclick: () => setNav(!showNav)
								})
						}),
						this.viewLogo(),
						m(MediaQuery, {
							minWidth: 1199,
							view: () =>
								m('.header-row-flex', [this.viewNav(), this.viewSideNav()])
						}),
						m(MediaQuery, {
							maxWidth: 1199,
							view: () =>
								m('.header-row-flex', {class: showNav ? 'state-open' : ''}, [
									this.viewSearch(),
									this.viewNav(),
									m('nav.header-nav-side', [
										m(MediaQuery, {
											maxWidth: 1199,
											view: () =>
												m(Link,
													{
														...action('/', () => setNav(false)),
														title: 'SMEunited'
													},
													m(Image, {class: 'header-nav-logo', ...logo})
												)
										}),
										this.viewSideNavLinks()
									])
								])
						})
					]),
					m('.header-title'),
					this.children
				]
			)
		])
	}
	viewLogo() {
		const {links} = this.attrs
		return m('a.header-logo', {...action(links.home.url), title: 'SMEunited'}, [
			m(Image, {
				class: 'header-logo-image',
				alt: 'SMEunited logo',
				...logo
			})
		])
	}

	viewNav() {
		const {menu} = this.attrs
		return m('nav.header-nav',
			menu && menu.map(item => this.viewNavItem(item, 'header-nav-link'))
		)
	}

	viewSideNav() {
		const {channel} = this.attrs
		return m('nav.header-nav-side',
			{...classes({mod: channel != 'homepage' ? 'small' : ''})},
			[this.viewSearch(), this.viewSocialLinks(), this.viewSideNavLinks()]
		)
	}

	viewSideNavLinks() {
		const {side_menu} = this.attrs
		return (
			side_menu &&
			side_menu.map(item => this.viewNavItem(item, 'header-nav-side-link'))
		)
	}

	viewSearch() {
		const {setNav, showNav} = this.attrs
		let inputvalue = ''
		return m('.header-searchcontainer', [
			m('.header-searchcontainer-search',
				m('input.header-searchcontainer-search-input', {
					type: 'text',
					name: 'header-search',
					placeholder: t('search.term'),
					onchange: e => {
						if (!e.target.value || e.target.value === '') return
						inputvalue = e.target.value
						action.navigate('/search?query=' + inputvalue)
						setNav(!showNav)

						e.target.value = ''
					}
				})
			),
			m('button',
				{
					className: 'header-searchcontainer-link',
					ariaLabel: 'Search'
				},
				m(Image, {
					class: 'header-searchcontainer-search-image',
					src: searchImg,
					alt: 'searchImage'
				})
			)
		])
	}

	viewNavItem(item: LinkType, className: string) {
		const {setNav} = this.attrs
		const {search} = window.location
		const query = item.url.split('?')[1]
		const label = query && m.parseQueryString(query).label
		const params = search[0] === '?' && m.parseQueryString(search.substr(1))
		return m(Link,
			{
				mod: ['navigation', 'scaleonhover', 'scaleonhover-white'],
				...action(item.url, () => setNav(false)),
				class: classes(className, {
					is: {
						active:
							(label && params && label === params.label) ||
							action.isActive(item.url)
					}
				}).className
			},
			item.title
		)
	}

	viewSocialLinks() {
		return m('.header-nav-side-social', [
			this.viewSocialLink('linkedin'),
			this.viewSocialLink('twitter'),
			this.viewSocialLink('bluesky'),
			this.viewSocialLink('facebook')
		])
	}

	viewSocialLink(key: string) {
		const {social} = this.attrs
		if (!social.links[key].url) return null

		return m('a.header-nav-side-social-link',
			{
				href: social.links[key].url,
				target: social.links[key].target,
				title: social.links[key]?.description || social.links[key].title,
				class: key
			},
			m(Icon, {
				icon: key
			})
		)
	}
}
